import React from 'react'
import { Link } from 'react-router-dom'
import * as routes from '../../constants/routes'

import Button from '@material-ui/core/Button'
const styles = {
    root : {
        backgroundColor: '#3f51b5',
        padding: '16px',
        width: '100%'
    },
    wrapperLeft: {
        display: 'inline-block',
        //width: '33.2%',
        //backgroundColor: 'blue'
    },
    wrapperCenter: {
        display: 'inline-block',
        //width: '33.2%',
        //backgroundColor: 'green'

    },
    wrapperRight: {
        display: 'inline-block',
        //width: '33.2%',
        textAlign: 'right'
        //backgroundColor: 'red'
    }


}

const Footer = props => {

    return (
        <div style={styles.root}>
            <div style={styles.wrapperLeft}>
            <Link to={routes.DATENSCHUTZ} >
                <Button style={{color: 'white'}} variant='outlined'>Datenschutzerklärung</Button>
            </Link>
            </div>
            <div style={styles.wrapperCenter}></div>
            <div style={styles.wrapperRight}>
            </div>

        </div>
    )
}

export default Footer


// WEBPACK FOOTER //
// ./src/Components/App/Footer.js